














import { Component, Prop, Vue } from 'vue-property-decorator';

type AcceptTou = {
  value: string;
};

const AuthFieldAcceptTouLabel = Vue.component('AuthFieldAcceptTouLabel', {
  render(h) {
    const _doc = this.$tc('commons.sentences.account.terms-and-conditions.doc-tou.title') as string;
    const _sentences = (this.$t('commons.actions.auth.consent-document', { document: '|X-X|' }) as string).split(
      '|X-X|',
    );

    return h('div', [
      _sentences[0],
      h(
        'u',
        {
          domProps: {
            innerHTML: _doc,
          },
          attrs: {
            class: ['black--text', 'pointer'],
          },
          on: {
            '!click': (event: any) => {
              this.$pdc.bus!.emit('account:t&c:open', 'TOU');
              event.stopPropagation();
              event.preventDefault();
            },
          },
        },
        this.$slots.default,
      ),
      _sentences[1],
    ]);
  },
});

@Component({
  components: {
    AuthFieldAcceptTouLabel,
  },
})
export default class AuthFieldAcceptTou extends Vue {
  @Prop({ required: true }) private acceptTou!: AcceptTou['value'];
  @Prop(Boolean) protected disabled!: boolean;

  get value(): AcceptTou['value'] {
    return this.acceptTou;
  }

  set value(value: AcceptTou['value']) {
    this.$emit('update:acceptTou', value);
  }
}
